"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var CloseCircle = function CloseCircle(_a) {
  var size = _a.size,
      props = tslib_1.__rest(_a, ["size"]);

  return react_1.default.createElement("svg", tslib_1.__assign({
    height: size,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), react_1.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12ZM8.62498 3.37502C8.83209 3.58213 8.83209 3.91791 8.62498 4.12502L6.75001 6.00002L8.62499 7.87503C8.8321 8.08213 8.8321 8.41792 8.62499 8.62503C8.41789 8.83213 8.08211 8.83213 7.875 8.62503L6.00002 6.75002L4.12504 8.62501C3.91794 8.83212 3.58216 8.83212 3.37505 8.62501C3.16795 8.41791 3.16795 8.08212 3.37505 7.87501L5.25003 6.00002L3.37506 4.12503C3.16796 3.91793 3.16796 3.58214 3.37506 3.37504C3.58217 3.16793 3.91795 3.16793 4.12505 3.37504L6.00002 5.25002L7.87499 3.37502C8.0821 3.16792 8.41788 3.16792 8.62498 3.37502Z",
    fill: "currentColor"
  }));
};

exports.default = CloseCircle;